import withRouter from "components/Common/withRouter";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import ToastDialog from "components/Common/ToastDialog";
import { FieldArray, FormikProvider, useFormik } from "formik"
import * as Yup from "yup"
import Loader from "react-spinner-loader"
import classnames from "classnames";
import { getEntityDetails,getShareholdingList } from "http/fundLync/entityAndAddress.helper";

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
  Modal,
  ModalHeader,
  Input,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";

//Import Breadcrumb
import { getDealInfo } from "../../http/fundLync/deal.helper";
import { callAddQuery, callGetQueryByEntity } from "../../http/fundLync/query.helper";
import { downloadSystemConfigFile } from "../../http/UAM/systemConfig.helper";
import { callBankList } from "http/fundLync/common.helper";
import { callEditDealFinancier, callGetDealFinancierInfo } from "../../http/fundLync/dealFinancier";
import { uId, isPermission, decryptedValue } from "common/utility";
import { getUser } from "http/fundLync/user.helper";
import { formatDateString1 } from "pages/EntityDashboard/borrowingProfile";

//redux
const ViewDealFin = (props) => {
  document.title = "Deal | Fundlync";
  const [entity, setEntity] = useState(null);
  const [query, setQuery] = useState(null);
  const [dealFinInfo, setDealFinInfo] = useState([]);
  const urlParams = new URLSearchParams(window.location.search);
  const encodedId = urlParams.get("id");
  const decodedId = atob(encodedId);
  const [subscribemodal, setSubscribemodal] = useState(false);
  const dealFinId = urlParams.get("dealFinId");
  const decodedDealFinId = atob(dealFinId);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [dealInfoList, setDealInfoList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [isDropdownOpenQuery, setIsDropdownOpenQuery] = useState(false);
  const [errorSecured, setErrorSecured] = useState('');
  const [selectedisAdditional, setSelectedisAdditional] = useState('');
  const [isQueryRaised, setIsQueryRaised] = useState(false);
  const [isQuerySection, setIsQuerySection] = useState(false);
  const [queryResponse, setQueryResponse] = useState([]);
  const [customActiveTab, setCustomActiveTab] = useState("1");
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false)
  const [isLeadAssign, setIsLeadAssign] = useState(false)
  const UserInfo = decryptedValue(localStorage.getItem("user"));
  const [propertyInfoList, setPropertyInfoList] = useState([]);
  const [isDownloadMandate, setIsDownloadMandate] = useState(false);
  const [productNameList,setProductNameList] = useState()
  const [shareholderList, setShareholderList] = useState([])
  const [shareholderSection, setShareholderSection] = useState(false)
  const [shareholdingDate, setShareholdingDate] = useState()

  useEffect(() => {
    getQuery()
    checkPermissions()
    getDealInfo({ id: decodedId })
      .then((response) => {
        setEntity(response.data)
        getEntityInformation(response.data.entityId)
        setDealFields(response.data);
        callBankList({ page: 1, limit: 200, }).then((res) => {
        })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => { });
    callGetDealFinancierInfo({ id: decodedDealFinId })
      .then((response) => {
        if (response.status) {
          setDealFinInfo(response.data)
        } else {
          setDealFinInfo([])
        }
      }).catch((error) => {

      });
    const user = decryptedValue(localStorage.getItem("user"));
    getUser({ entityId: user.entityId })
      .then((response) => {
        if (response.code == 200 && response.status) {
          setUserList(response?.data?.data)
        }
      }).catch((error) => {
      })
  }, []);

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setCustomActiveTab(tab);
    }
  };

  const radioBtnValue = (value) => {
    if(value == null){
      return '-'
    }
    return value ? "Yes" : "No";
  };

  const goBack = () => {
    window.history.back();
  };

  const assignFunc = (ele) => {
    validation.setFieldValue('id', ele)
    setSubscribemodal(true);
  }

  const getEntityInformation = async (id) => {
    const bodyData = {
      entityId: id
    }
    const entityInfo = await getEntityDetails(bodyData);
    if (!entityInfo.status) {
      setToastInfo({ message: entityInfo.message, showToast: true, role: "error" });
    } 
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: "",
      assignTo: "",
    },
    validationSchema: Yup.object({
      id: Yup.number().required(""),
      assignTo: Yup.string().required("Please Select User to Assign Deal")
    }),
    onSubmit: values => {
      callEditDealFinancier({ id: values.id, status: 2, assignedTo: values.assignTo })
        .then((response) => {
          if (response.status) {
            setSubscribemodal(false);
            setToastInfo({
              message: 'Deal Assigned Succesfully',
              showToast: true,
              role: "success",
            });
            callGetDealFinancierInfo({ id: decodedDealFinId })
              .then((response) => {
                if (response.status) {
                  setDealFinInfo(response.data)
                } else {
                  setDealFinInfo([])
                }
              }).catch((error) => {

              });
          } else {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "error",
            });
          }
        }).catch((error) => {

        });
    }
  })

  const assignToMeFunc = () => {
    const user = decryptedValue(localStorage.getItem("user"));
    callEditDealFinancier({ id: decodedDealFinId, status: 2, assignedTo: user.id })
      .then((response) => {
        if (response.status) {
          setToastInfo({
            message: 'Deal Assigned Succesfully',
            showToast: true,
            role: "success",
          });
          callGetDealFinancierInfo({ id: decodedDealFinId })
            .then((response) => {
              if (response.status) {
                setDealFinInfo(response.data)
              } else {
                setDealFinInfo([])
              }
            }).catch((error) => {

            });
        } else {
          setToastInfo({
            message: response.message,
            showToast: true,
            role: "error",
          });
        }
      }).catch((error) => {

      });
  }

  const toggleDropdownQuery = () => {
    setIsDropdownOpenQuery(!isDropdownOpenQuery);
  };

  const handleRaiseQuery = () => {
    setIsQuerySection(!isQuerySection)
  };

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: (query?.id) || "",
      query: (query?.query) || "",
      isDocRequired: "",
      fileList: [],
    },
    validationSchema: Yup.object({
      query: Yup.string().required("Please Enter comment"),
      fileList: selectedisAdditional == 'Yes' ? Yup.array().of(
        Yup.object({
          fileName: Yup.string().required("File name is required"),
        })
      ) : Yup.array(),
      isDocRequired:
      selectedisAdditional == ""
        ? Yup.boolean().required("Please Select Option")
        : Yup.boolean(),
    }),
    onSubmit: (values) => {
      const entity = {
        dealId: decodedId,
        dealQuery: values.query,
      };
      if (selectedisAdditional == 'Yes') {
        entity.isDocRequired = true
        let newArr = values.fileList.map((ele) => {
          return ele.fileName
        })
        entity.fileList = newArr
      } else {
        entity.isDocRequired = false
      }
      setLoader(true)
      callAddQuery(entity)
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "success",
            });
            setLoader(false)
            validation2.resetForm()
            setIsQuerySection(!isQuerySection)
            getQuery()
          } else {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "error",
            });
            setLoader(false)
          }
        }).catch((error) => {
          setLoader(false);
        }).finally(f => {
          setLoader(false);
        })
    },
  });

  const handleCancelClicks = () => {
    validation2.resetForm();
    setQuery(null)
    setIsQuerySection(!isQuerySection)
  };

  const getQuery = () => {
    let countQuery = 0
    callGetQueryByEntity({ dealId: decodedId })
      .then((response) => {
        if (response.code == 200 && response.status) {
          response.data.data.forEach((ele) => {
            setQueryResponse(response.data.data)
            showQueryTimeline(response.data.data)
            if (!ele.dealQueryResponse) {
              setIsQueryRaised(true)
              countQuery++
            }
          })
          setCount(countQuery)
        }
      }).catch((error) => {
      })
  }

  const showQueryTimeline = (queryData) => {
    setQueryResponse(queryData)
  }

  const handleAddChange = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isDocRequired = true
      validation2.setFieldValue('fileList', [{ id: uId(), fileName: "" }])
      setSelectedisAdditional(event.target.value);
      setErrorSecured('');
    } else {
      validation.values.isDocRequired = false
      setSelectedisAdditional(event.target.value);
      setSelectedisAdditional(event.target.value);
      setErrorSecured('');
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedisAdditional == '') {
      setErrorSecured('Please select an option');
    }
  };

  const handleDelete = (rowIndex) => {
    validation2.values.fileList.splice(rowIndex, 1);
    validation2.validateForm();
  };

  const handleItemSelect = (data, value) => {
    data.type = value;
    validation.setFieldValue("type", value);
  };

  const formatDate = (oldDate) => {
    const isoDateString = oldDate;
    const date = new Date(isoDateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    const formattedDate = date.toLocaleDateString(undefined, options);

    return formattedDate;
  };

  const checkPermissions = async () => {
    const isLeadAssign = await isPermission("lead_assign", "edit_permission")
    setIsLeadAssign(isLeadAssign)

    const isDownload = await isPermission("download_mandate_copy", "view_permission")
    setIsDownloadMandate(isDownload)
  }

  const formatDateString = (date) => {
    if (date === null || date === undefined) {
      return null;
    }
    const inputDateString = date;
    const inputDate = new Date(inputDateString);

    const year = inputDate.getFullYear();
    const month = String(inputDate.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are zero-based
    const day = String(inputDate.getDate()).padStart(2, "0");

    const formattedDateString = `${day}-${month}-${year}`;
    return formattedDateString;
  }

  const capitalizeFirstLetter = (inputString) => {
    if (typeof inputString !== 'string' || inputString.length === 0) {
      return inputString;
    }
    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
  }

  const handleToast = (info) => {
    setToastInfo(info);
  };

  const setDealFields = (data) => {
    const { dealProductCommercials } = data;
    getAllProductsList(dealProductCommercials)
    const commonFields = [
      // { label: "Entity Type", value: data?.dealType },
      // { label: "Entity Name", value: data.entity.entityName },
      // { label: "Anchor Name", value: data.anchor?.entityName || "-" },
      { label: "Requested Loan Amount", value: data?.loanRequirement, format: formatNumberWithCommas },
      { label: "Rate of Interest", value: data?.rateOfInterest !== null ? data?.rateOfInterest + "%" : "-" },
      { label: "Tenure", value: data?.tenure },
      { label: "Loan Type", value: data?.loanType },
      { label: "Guarantee", value: data?.guarantee },
      { label: "Is loan secured?", value: data ? radioBtnValue(data?.isSecured) : null },
      { label: "Security Cover", value: data?.securityCover ? data.securityCover + "X" : null },
      // { label: "Deal Status", value: data.dealStatus },
      { label: "Deal Notes", value: data?.dealNotes },
    ];
  
    const dealInfoList = [...commonFields];
    dealProductCommercials.forEach(dealProduct => {
      const { productType, product } = dealProduct;
      if (productType === "Term loan" && product !== "Infrastructure loan") {
        dealInfoList.push(
          { label: "Selected End Use", value: data?.endUse },
          { label: "Selected Primary Security Type", value: data?.primarySecurity },
          { label: "What is the type of charge?", value: data?.typeOfCharge },
        );
      } else if (product === "Loan against Property") {
        dealInfoList.push(
          { label: "Selected End Use", value: data?.endUse },
          { label: "Selected Bank Name", value: data?.bankName },
          { label: "Is Bank Statement Password Protected?", value: data ? radioBtnValue(data?.isPasswordBankStatement) : null },
          { label: "Entered Bank Statement Password", value: data?.bankStatementPassword },
          { label: "Is there An Income source other Than that declared In the income tax returns that may contribute to the repayment of this loan?", value: data ? radioBtnValue(data?.isOtherIncomeSource) : null },
          { label: "Other Income Amount", value: (data?.otherIncomeAmount || ''), format: formatNumberWithCommas },
          { label: "Is There Co-borrower For This Loan?", value: data ? radioBtnValue(data?.isCoBorrower) : null },
          { label: "Enter Name of The Co-borrower", value: data?.coBorrowerName },
          { label: "D.O.B of The Co-borrower", value: data?.coBorrowerDob, format: formatDateString },
          { label: "Selected Relationship With The Co-borrower", value: data?.coBorrowerRelation },
          { label: "Enter PAN No. of The Co-borrower", value: data?.coBorrowerPanNumber },
          { label: "Income Type of The Co-borrower", value: data?.coBorrowerIncomeType }
        );
        setPropertyInfoList(
          data?.propertyInfo.map((obj) =>
            Object.assign(obj, { id: uId() })
          )
        );
      } else if (product === "Equipment Finance") {
        dealInfoList.push(
          { label: "Selected End Use", value: data?.endUse },
          { label: "Selected Primary Security Type", value: data?.primarySecurity },
          { label: "What is the type of charge?", value: data?.typeOfCharge },
          { label: "Equipment Category", value: data?.equipmentCategory },
          { label: "Equipment Sub-category", value: data?.equipmentSubCategory },
          { label: "Equipment Type", value: data?.equipmentType },
        );
      }else if (product === "Payable Financing" || product === "Forfaiting" || product === "Buyers Credit" || product === "Suppliers Credit") {
        dealInfoList.push(
          { label: "When are vendors currently paid?", value: data?.vendorPay },
          { label: "What is the Business Requirement?", value: data?.businessRequirement },
          { label: "If the lender disburses on Day 1, what cash discount would be received from vendors?", value: data?.vendorDiscount },
          { label: "By how many days would the DPO be extended?", value: data?.extendDpoDays },
          { label: "Is there an existing vendor financing arrangement?", value: data ? radioBtnValue(data?.isVendorArrangement) : null },
          { label: "Selected the entity types with which arrangements have been made", value: data?.vendorsArrangement },
          { label: "Willing to provide any guarantee to the lender?", value: data ? radioBtnValue(data?.isGuaranteeLender) : null },
          { label: "Select the Guarantee type(s)", value: data?.guaranteeTypesLender },
          { label: "What is the value of monthly purchases?", value: data?.monthlyPurchases, format: formatNumberWithCommas }
        );
      } else if (product === "Receivable Financing" || product === 'Inventory funding') {
        dealInfoList.push(
          { label: "Is there a credit period being offered to dealers and distributors?", value: data ? radioBtnValue(data?.isCreditPeriod) : null },
          { label: "What is the average credit period currently offered? (in days)", value: data?.creditPeriod !== 0 ? data?.creditPeriod : null },
          { label: "What is the Business Requirement?", value: data?.businessRequirement },
          { label: "Is there an existing dealer financing arrangement?", value: data ? radioBtnValue(data?.isDealerArrangement) : null },
          { label: "Selected the entity types with which arrangements have been made", value: data?.dealerArrangement },
          { label: "What percentage of dealers are covered by the existing arrangement?", value: data?.percentageCovered ? data?.percentageCovered + '%' : null },
          { label: "Geographically sale North", value: data?.northSales ? data.northSales + "%" : null },
          { label: "Geographically sale South", value: data?.southSales ? data.southSales + "%" : null },
          { label: "Geographically sale East", value: data?.eastSales ? data.eastSales + "%" : null },
          { label: "Geographically sale West", value: data?.westSales ? data.westSales + "%" : null },
          { label: "Is cash discount provided to dealers and distributors?", value: data ? radioBtnValue(data?.isCashDiscount) : null },
          { label: "Would a first loss default guarantee (FLDG) be offered to the lender?", value: data ? radioBtnValue(data?.isFldg) : null },
          { label: "Please mention the maximum percentage of FLDG willing to be provided", value: data?.fldg ? data.fldg + "%" : null },
          { label: "What is the value of monthly sales?", value: data?.monthlySales, format: formatNumberWithCommas }
        );
      } else if (product === "Equity") {
        dealInfoList.push(
          { label: "What % of equity to be diluted?", value: data?.percentageOfEquityDiluted !== null ? data?.percentageOfEquityDiluted + "%" : "-"  },
          { label: "Has the valuation being done?", value: radioBtnValue(data?.isValuationDone) },
          { label: "What kind of investors accepted to the company?", value: data?.investorsType },
          { label: "Whether it is preference share equity or normal equity?", value: data?.equityType },
          { label: "What is the purpose of raising Equity?", value: data?.purposeOfRaisingEquity },
          { label: "Is it fresh equity or diluted?", value: data?.freshOrDiluted },
          { label: "Whose equity is being diluted?", value: data?.dilutedEquityHolder },
        );
        if(data){
          getShareholdingList({ entityId: data?.entityId })
            .then((response) => {
              setShareholderSection(true)
              const allshareholdings = response.data?.data || [];
              if (allshareholdings.length > 0) {
                const formatedDate = formatDateString1(
                  allshareholdings[0].shareholdingAsOf
                );
                allshareholdings[0].shareholdingAsOf = formatedDate;
                setShareholdingDate(response.data?.data[0].shareholdingAsOf)
                setShareholderList(response.data?.data[0].shareholderList)
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (product === "Forfaiting") {
        dealInfoList.push(
          { label: "What is the capex equipment being imported?", value: data?.capexEquipmentImported },
          { label: "which bank will abalize or co-accept the bill of exchange?", value: data?.bankAvalizingBill },
        );
      } else if (product === "Debetures") {
        dealInfoList.push(
          { label: "Whether the debentures are secured or unsecured?", value: data?.debenturesSecuredOrUnsecured },
          { label: "Whether the Debentures are rated or unrated?", value: data?.debenturesRatedOrUnrated },
          { label: "Purpose of issuing Debentures?", value: data?.purposeOfIssuingDebentures },
        );
      } else if (product === "Commercial paper") {
        dealInfoList.push(
          { label: "Purpose of issuing Commercial Paper?", value: data?.purposeOfIssuingCommercial },
          { label: "Whether the Commercial Papers are rated or unrated?", value: data?.commercialRatedOrUnrated },
          { label: "What is the coupon?", value: data?.coupon },
        );
      } else if (product === "Securitisation") {
        dealInfoList.push(
          { label: "Whether the pool is securitise as PSL or non PSL?", value: data?.poolPSLorNonPSL },
          { label: "Whether the pool is rated or unrated?", value: data?.poolRatedOrUnrated },
          { label: "What is the coupon which are looking for?", value: data?.desiredCoupon },
          { label: "What is the ageing of the pool?", value: data?.poolAgeing },
        );
      }
    });
  
    setDealInfoList(dealInfoList);
  }

  const getAllProductsList = (dealProductCommercials) =>{
    let productNameList = []
    dealProductCommercials.map((dealProduct)=>{
      const {product} = dealProduct;
      const { subProduct } = dealProduct;
      const { productType } = dealProduct;
      let obj = {
        product,
        subProduct,
        productType
      }
      productNameList.push(obj)
    })
    setProductNameList(productNameList)
  }

  const formatLenderName = (name) => {
    if (!name) return '-';
  
    let formattedName = name
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  
    formattedName = formattedName.replace(/\(([^)]+)\)/g, (match, p1) => {
      let transformedContent = p1
        .split(' ')
        .map(word => {
          if (word.toLowerCase() === 'nris') {
            return "NRI's";
          }
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ');
      return `(${transformedContent})`;
    });
  
    return formattedName;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <h4 className="mb-4">Deal</h4>
          <Row className="vertical-scroll">
            <Col xs="12">
              {(!UserInfo.EntityAssignedFlag || (dealFinInfo?.assignedTo !== null && dealFinInfo.assignedTo == UserInfo.id)) && (
                <Nav tabs className="nav-tabs-custom nav-justified mb-4">
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "1",
                      })}
                      onClick={() => {
                        toggleCustom("1");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="fas fa-home"></i>
                      </span>
                      <span className="d-none d-sm-block">Deal</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: customActiveTab === "2",
                      })}
                      onClick={() => {
                        toggleCustom("2");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-user"></i>
                      </span>
                      <span className="d-none d-sm-block">Query (Pending {count})</span>
                    </NavLink>
                  </NavItem>
                </Nav>
              )}

              <TabContent
                activeTab={customActiveTab}
                className="text-muted"
              >
                <TabPane tabId="1">
                  <div style={{ padding: "10px" }}>
                    {/* <div
                      className="d-flex justify-content-between mt-1"
                    >
                      <div>
                        <h5>Details</h5>
                      </div>
                    </div> */}
                    <div>
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          handleSubmit(e);
                          return false;
                        }}
                      >
                        <div className="mb-3 row">
                          <Row>
                            <Col sm="12">
                              <div className="d-flex gap-3 justify-content-between align-items-center">
                                <h4>Details</h4>
                                <button
                                  className="btn btn-outline-secondary me-2"
                                  type="button"
                                  onClick={goBack}
                                >
                                  Back
                                </button>
                              </div>
                            </Col>
                          </Row>

                          <Col sm="6" md="6">
                            <Label
                              className={`form-label mt-1 mb-1 grey`}
                            >
                              <b>Entity Type</b>
                            </Label>
                            <p style={{ fontSize: "14px" }}>
                              {entity?.dealType || "-"}
                            </p>
                          </Col>
                          <Col sm="6" md="6">
                            <Label
                              className={`form-label mt-1 mb-1 grey`}
                            >
                              <b>Entity Name</b>
                            </Label>
                            <p style={{ fontSize: "14px" }}>
                              {entity?.entity?.entityName || "-"}
                            </p>
                          </Col>
                          {entity?.dealType == 'Counterparty' && (<Col sm="6" md="6">
                            <Label
                              className={`form-label mt-1 mb-1 grey`}
                            >
                              <b>Anchor Name</b>
                            </Label>
                            <p style={{ fontSize: "14px" }}>
                              {entity?.anchor?.entityName || "-"}
                            </p>
                          </Col>)}
                          {entity?.prospectiveProduct && (<Col sm="6" md="6">
                            <Label
                              className={`form-label mt-1 mb-1 grey`}
                            >
                              <b>Prospective Product</b>
                            </Label>
                            <p style={{ fontSize: "14px" }}>
                              {entity?.prospectiveProduct || "-"}
                            </p>
                          </Col>)}
                          {entity?.proposalType && (<Col sm="6" md="6">
                            <Label
                              className={`form-label mt-1 mb-1 grey`}
                            >
                              <b>Proposal type</b>
                            </Label>
                            <p style={{ fontSize: "14px" }}>
                              {entity?.proposalType || "-"}
                            </p>
                          </Col>)}
                          <div style={{ margin: '1%', borderTop: '0.5px solid #d7d7d7' }}></div>


                          {productNameList?.map((field, index) => (
                            <>
                              <div className="mt-1">
                                <div>
                                  <Row>
                                    <Col key={field.id} sm="6" md="6">
                                      <Label
                                        className={`form-label mt${index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                      >
                                        <b>Product Type</b>
                                      </Label>
                                      <p style={{ fontSize: "14px" }}>
                                        {field.productType || "-"}
                                      </p>
                                    </Col>
                                    <Col key={field.id} sm="6" md="6">
                                      <Label
                                        className={`form-label mt${index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                      >
                                        <b>Product</b>
                                      </Label>
                                      <p style={{ fontSize: "14px" }}>
                                        {field.product || "-"}
                                      </p>
                                    </Col>
                                    {field?.subProduct && (<Col key={field.id} sm="6" md="6">
                                      <Label
                                        className={`form-label mt${index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                      >
                                        <b>Sub Product</b>
                                      </Label>
                                      <p style={{ fontSize: "14px" }}>
                                        {field.subProduct || "-"}
                                      </p>
                                    </Col>)}
                                  </Row>
                          <div style={{ margin: '1%', borderTop: '0.5px solid #d7d7d7' }}></div>

                                </div>
                              </div>
                            </>
                          ))}

                          {shareholderSection && shareholderList?.length !== 0 && (
                            <div className="mb-4 mt-4" style={{  padding: "15px 15px 0 25px", borderRadius: "3px" }}>
                              {shareholderList?.length !== 0 ? (
                                <Row>
                                  <Col sm="6" className="mb-2">
                                    <span className="font-size-14 entityDetailsValue"><span className="text-success">Shareholding As Of : </span>{formatDateString(shareholdingDate)}</span>{" "}
                                  </Col>
                                </Row>
                              ) : (null)}
                              {shareholderList?.length !== 0 ? (
                                shareholderList?.map((shareholder, index) => (
                                  <React.Fragment key={index}>
                                    <Row className="mt-3">
                                      <Col sm="6" md="6" lg="4" className="mb-1">
                                        <Label className="d-block entityDetails">Shareholder Name</Label>
                                        <span className="mb-0 entityDetailsValue">{shareholder.shareholderName || '-'}</span>
                                      </Col>
                                      <Col sm="6" md="6" lg="4" className="mb-1">
                                        <Label className="d-block entityDetails">Shareholder Type</Label>
                                        <span className="mb-0 entityDetailsValue">{formatLenderName(shareholder.shareholderType) || '-'}</span>
                                      </Col>
                                      <Col sm="6" md="6" lg="4" className="mb-1">
                                        <Label className="d-block entityDetails">Holding Percentage</Label>
                                        <span className="mb-0 entityDetailsValue">
                                          {shareholder.percentageHolding !== undefined && shareholder.percentageHolding !== null && shareholder.percentageHolding
                                            ? `${shareholder.percentageHolding}%`
                                            : '-'}
                                        </span>
                                      </Col>
                                    </Row>

                                    <div style={{ marginTop: '1%', borderTop: '0.5px solid #d7d7d7' }}></div>
                                  </React.Fragment>
                                ))
                              ) : (
                                <div className="mt-5">
                                  <p className="text-center">No Shareholding records available.</p>
                                </div>
                              )}
                            </div>
                          )}

                          {dealInfoList?.map((field, index) => (
                            (field.value && field.value !== '-') && (<Col key={uId()} sm="6" md="6">
                              <Label
                                className={`form-label mt-${index % 2 === 0 ? "2" : "1"
                                  }mb-1 grey`}
                              >
                                <b>{field.label}</b>
                              </Label>
                              <p style={{ fontSize: "14px" }}>
                                {field.format
                                  ? field.format(field.value)
                                  : field.value || '-'}
                              </p>
                            </Col>)
                          ))}
                          {entity?.bankStatement && (
                            <Col sm="6" md="6">
                              <>
                                <Label className="mt-2 mb-1 grey">
                                  <b>Download Bank Statement</b>
                                </Label>
                                <br />
                                <i
                                  className="mdi mdi-download"
                                  style={{ fontSize: "25px", cursor: "pointer", color: '#34c38f' }}
                                  onKeyUp={() => { }}
                                  onClick={() => {
                                    formatFunction(entity?.bankStatement, handleToast)
                                  }}
                                ></i>
                              </>
                            </Col>
                          )}
                          {entity?.coBorrowerPan && (
                            <Col sm="6" md="6">
                              <>
                                <Label className="mt-2 mb-1 grey">
                                  <b>Download Co-borrower PAN</b>
                                </Label>
                                <br />
                                <i
                                  className="mdi mdi-download"
                                  style={{ fontSize: "25px", cursor: "pointer", color: '#34c38f' }}
                                  onKeyUp={() => { }}
                                  onClick={() => {
                                    formatFunction(entity?.coBorrowerPan, handleToast)
                                  }}
                                ></i>
                              </>
                            </Col>
                          )}
                          {entity?.coBorrowerItr && (
                            <Col sm="6" md="6">
                              <>
                                <Label className="mt-2 mb-1 grey">
                                  <b>Download ITR Documents</b>
                                </Label>
                                <br />
                                <i
                                  className="mdi mdi-download"
                                  style={{ fontSize: "25px", cursor: "pointer", color: '#34c38f' }}
                                  onKeyUp={() => { }}
                                  onClick={() => {
                                    formatFunction(entity?.coBorrowerItr, handleToast)
                                  }}
                                ></i>
                              </>
                            </Col>
                          )}
                          {entity?.cmaDoc && (
                            <Col sm="6" md="6">
                              <>
                                <Label className="mt-2 mb-1 grey">
                                  <b>Download CMA Documents</b>
                                </Label>
                                <br />
                                <i
                                  className="mdi mdi-download"
                                  style={{ fontSize: "25px", cursor: "pointer", color: '#34c38f' }}
                                  onKeyUp={() => { }}
                                  onClick={() => {
                                    formatFunction(entity?.cmaDoc, handleToast)

                                  }}
                                ></i>
                              </>
                            </Col>
                          )}
                          {propertyInfoList?.length > 0 && (
                            <Col sm="12" lg='12'>
                              {propertyInfoList.map(
                                (file, index) => (
                                  <TableRow2
                                    key={file.id}
                                    index={index}
                                    validation={propertyInfoList}
                                  />
                                )
                              )}

                            </Col>
                          )}
                          {entity?.isEsign != '0' && isDownloadMandate &&(
                            <Col sm="6" md="6">
                              <>
                                <Label className="mt-2 mb-1 grey">
                                  <b>Mandate Letter</b>
                                </Label>
                                <br />
                                <i
                                  className="mdi mdi-download"
                                  style={{ fontSize: "25px", cursor: "pointer", color: '#34c38f' }}
                                  onKeyUp={() => { }}
                                  onClick={() => {
                                    formatFunction(entity?.signedUser?.signedDocumentUrl, handleToast)
                                  }}
                                  title={'Download Mandate Letter'}
                                ></i> {' '} {entity?.isEsign == '1' ? (
                                  `Signed by ${entity?.signedUser?.firstName} ${entity?.signedUser?.lastName} on ${formatDate(entity?.signedUser?.signedAt)}`
                                ) : (
                                  `Uploaded by ${entity?.signedUser?.firstName} ${entity?.signedUser?.lastName} on ${formatDate(entity?.signedUser?.signedAt)}`
                                )}

                              </>
                            </Col>
                          )}

                        </div>
                        <Row>
                          <Col sm="12">
                            <div className="d-flex gap-3 justify-content-end" style={{marginRight:"33px"}}>
                              <button
                                className="btn btn-outline-secondary "
                                type="button"
                                onClick={goBack}
                              >
                                Back
                              </button>
                              {!UserInfo.EntityAssignedFlag || (isLeadAssign && dealFinInfo?.assignedTo == null) && (
                                <button
                                  className="btn btn-outline-primary"
                                  type="button"
                                  onClick={() => { assignFunc(decodedDealFinId) }}
                                >
                                  Assign
                                </button>
                              )}
                              {!UserInfo.EntityAssignedFlag || dealFinInfo?.assignedTo == null && (
                                <button
                                  className="btn btn-outline-success"
                                  type="button"
                                  onClick={assignToMeFunc}
                                >
                                  Assign to me
                                </button>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </div>
                </TabPane>
                {(!UserInfo.EntityAssignedFlag || (dealFinInfo?.assignedTo !== null && dealFinInfo.assignedTo == UserInfo.id)) && (
                  <TabPane tabId="2">
                    <div style={{ padding: "10px" }}>
                      <div
                        className="d-flex justify-content-between mt-1"
                        style={{ cursor: "pointer" }}
                        onKeyUp={() => { }}
                        onClick={toggleDropdownQuery}
                      >
                        <div>
                          <h5>Query</h5>
                        </div>
                      </div>
                      <div>
                        <Row>
                          <Col sm="12" >
                            {!isQueryRaised && (
                              <div className="d-flex gap-3 justify-content-start mb-3">
                                <button
                                  className="btn btn-outline-primary"
                                  type="button"
                                  onClick={handleRaiseQuery}
                                >
                                  Raise Query
                                </button>
                              </div>
                            )}

                            {isQuerySection && (
                              <FormikProvider value={validation2}>
                                <Form
                                  onSubmit={(e) => {
                                    e.preventDefault();
                                    validation2.handleSubmit();
                                    handleSubmit(e)

                                    return false;
                                  }}
                                >
                                  <Row className="mb-3 row">
                                    <Col sm="12" md="6">
                                      <Label className="form-label mt-4">Comment*</Label>
                                      <Input
                                        name="query"
                                        type="textarea"
                                        placeholder="Add Comment"
                                        onChange={validation2.handleChange}
                                        onBlur={validation2.handleBlur}
                                        value={validation2.values.query || ""}
                                        invalid={
                                          !!(validation2.touched.query && validation2.errors.query)
                                        }
                                      />
                                      {validation2.touched.query && validation2.errors.query ? (
                                        <FormFeedback type="invalid">
                                          {validation2.errors.query}
                                        </FormFeedback>
                                      ) : null}
                                    </Col>
                                    <Col sm="12" md="7">
                                      <Label className="form-label mt-4">Is Additional documents required?*</Label>
                                      <div className="d-flex ms-4">
                                        <div>
                                          <Input
                                            type="radio"
                                            id="isAdditional1"
                                            value="Yes"
                                            onChange={() => { }}
                                            style={{ border: "1px solid black" }}
                                            checked={selectedisAdditional == 'Yes'}
                                            onClick={handleAddChange}
                                          />
                                          <Label htmlFor="isAdditional1" className="ms-2">Yes</Label>
                                        </div>
                                        <div className="ms-4">
                                          <Input
                                            type="radio"
                                            id="isAdditional2"
                                            onChange={() => { }}
                                            value="No"
                                            style={{ border: "1px solid black" }}
                                            checked={selectedisAdditional == 'No'}
                                            onClick={handleAddChange}
                                          />
                                          <Label htmlFor="isAdditional2" className="ms-2">No</Label>
                                        </div>
                                      </div>
                                      {errorSecured && <p style={{ color: 'rgb(245,116,116)', fontSize: "11px" }} className="ms-4">{errorSecured}</p>}
                                    </Col>
                                    {selectedisAdditional == 'Yes' && (
                                      <Col sm="12" className="mt-2">
                                        <table>
                                          <thead>
                                            <tr>
                                              <td style={{ fontWeight: '500' }}>Document Name</td>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <FieldArray
                                              name="fileList"
                                              render={(arrayHelpers) => (
                                                <>
                                                  {validation2.values.fileList.map(
                                                    (file, index) => (
                                                      <TableRow
                                                        key={file.id}
                                                        onDelete={handleDelete}
                                                        onItemSelect={handleItemSelect}
                                                        index={index}
                                                        validation={validation2}
                                                      />
                                                    )
                                                  )}
                                                  <span
                                                    className="text-success"
                                                    style={{ cursor: "pointer" }}
                                                    onKeyUp={() => { }}
                                                    onClick={() => {
                                                      arrayHelpers.push({
                                                        fileName: "",
                                                      });
                                                    }}
                                                  >
                                                    <i className="mdi mdi-plus me-1" /> Add
                                                    File
                                                  </span>
                                                </>
                                              )}
                                            />
                                          </tbody>
                                        </table>
                                      </Col>
                                    )}
                                  </Row>

                                  <Row>
                                    <Col>
                                      <div className="d-flex gap-3 justify-content-end">
                                        <button
                                          type="button"
                                          className="btn btn-outline-secondary"
                                          onClick={handleCancelClicks}
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          type="submit"
                                          className="btn btn-success save-customer"
                                        >
                                          Save
                                        </button>
                                      </div>
                                    </Col>
                                  </Row>
                                </Form>
                              </FormikProvider>
                            )}

                            {!isQuerySection && (
                              <div>
                                <ul className="verti-timeline list-unstyled">
                                  {queryResponse.length > 0 && (
                                    queryResponse.map((query, index) => (
                                      <li key={query.id} className="event-list">
                                        <div className="event-timeline-dot">
                                          <i
                                            className='bx bx-right-arrow-circle'
                                          />
                                        </div>
                                        <div>
                                          <Card className="flex-grow-1">
                                            <CardBody style={{ backgroundColor: 'rgb(249,251,252)', border: query.dealQueryResponse ? '1.5px solid green' : 'none', borderRadius: '2.5px' }}>
                                              {query.dealQueryResponse && (
                                                <div className="d-flex ">
                                                  <Col lg="11">
                                                    <span className="text-secondary">Reply: </span>
                                                    <span className="text-muted font-size-14"><span className="text-success">"{query.dealQueryResponse}".</span> <br />
                                                      <span className="text-secondary font-size-12 ms-4">(by {query.updatedByUser?.first_name} {query.updatedByUser?.last_name} from <span className="text-warning">{query.deal.entity.entity_name}</span>, {formatDate(query.updatedAt)})</span>
                                                    </span><br />
                                                    {query.isDocRequired && (
                                                      <div className="ms-4">
                                                        {query.fileUploads?.map((ele) => (
                                                          <div key={ele.id} className="d-flex gap-1"
                                                            onKeyUp={() => { }}
                                                            onClick={() => {
                                                              formatFunction(ele?.file_upload, handleToast)
                                                            }}>
                                                            <span>{ele.file_name}</span>
                                                            <i
                                                              className="mdi mdi-download font-size-16 text-success"
                                                              style={{ cursor: "pointer" }}
                                                            ></i>
                                                          </div>
                                                        ))}
                                                      </div>
                                                    )}

                                                  </Col>
                                                </div>
                                              )}

                                              <br />

                                              <div>
                                                <Col lg="11">
                                                  <span className="text-secondary">Query: </span>
                                                  <span className="text-muted font-size-14"><span className="text-primary">"{query.dealQuery}".</span> <br />
                                                    {query.isDocRequired && (
                                                      <div className="ms-4">
                                                        {query.fileUploads?.map((ele) => (
                                                          <ul key={ele.id}>
                                                            <li>{ele.file_name} </li>
                                                          </ul>
                                                        ))}
                                                      </div>
                                                    )}
                                                    <span className="text-secondary font-size-12 ms-4">(by {query.user?.first_name} {query.user?.last_name} from <span className="text-warning">{query.entity.entityName}</span>, {formatDate(query.updatedAt)})</span>
                                                  </span><br />
                                                </Col>
                                              </div>

                                            </CardBody>
                                          </Card>
                                        </div>
                                      </li>
                                    ))
                                  )}
                                </ul>
                              </div>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </TabPane>
                )}
              </TabContent>

            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        isOpen={subscribemodal}
        role="dialog"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setSubscribemodal(!subscribemodal);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setSubscribemodal(!subscribemodal);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <h4 className="text-success">Select User to Assign Deal</h4>
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Col xl={12} >
                    <Input
                      name="assignTo"
                      type="select"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.assignTo || ""}
                      invalid={
                        !!(validation.touched.assignTo && validation.errors.assignTo)
                      }
                    >
                      <option value="" disabled>Select User</option>
                      {userList?.map((option, index) => (
                        <option key={option.id} value={option.id}>
                          {capitalizeFirstLetter(option.firstName) + ' ' + ((option.lastName) ? capitalizeFirstLetter(option.lastName) : '')}
                        </option>
                      ))}

                    </Input>
                    {validation.touched.assignTo && validation.errors.assignTo ? (
                      <FormFeedback type="invalid">
                        {validation.errors.assignTo}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Row>
                    <Col sm="12" >
                      <div className="d-flex gap-3 justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-success save-customer mt-2"
                        >
                          Assign
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={modal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        toggle={() => {
          setModal(!modal);
        }}
      >
      </Modal>

      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      <Loader show={loader} type="box" message="Raising Query" />
    </React.Fragment >
  );
};

export default withRouter(ViewDealFin);

ViewDealFin.propTypes = {
  history: PropTypes.object,
};

function downloadFile(base64String, ext, fileName) {
  let source = "";
  if (ext == "zip") {
    source = `data:application/zip;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();
  } else {
    source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();
  }
}

const TableRow = ({ onDelete, index, validation }) => {

  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`fileList.${index}.${field}`, value);
  };

  return (
    <tr>
      <td style={{ padding: '10px' }}>
        <Input
          type="text"
          placeholder="Enter file Name"
          name={`file[${index}].name`}
          id={`file[${index}].name`}
          value={validation.values.fileList[index].fileName}
          onChange={(e) =>
            handleInputChange(index, "fileName", e.target.value)
          }
          invalid={
            !!(validation.touched.fileList?.[index]?.fileName &&
              validation.errors.fileList?.[index]?.fileName)
          }
        />
        {validation.touched.fileList?.[index]?.fileName &&
          validation.errors.fileList?.[index]?.fileName && (
            <FormFeedback>
              {validation.errors.fileList[index].fileName}
            </FormFeedback>
          )}
      </td>
      <td>

        {validation.values?.fileList?.length > 1 && (
          <i
            className="bx bx-x-circle text-danger"
            onKeyUp={() => { }}
            onClick={() => onDelete(index)}
            style={{ cursor: "pointer", fontSize: "17px" }}
          />
        )}
      </td>
    </tr>
  );

};

const TableRow2 = ({ index, validation }) => {
  const [toastInfo, setToastInfo] = useState({ showToast: false });

  const handleToast = (info) => {
    setToastInfo(info);
  };

  return (
    <div className="mt-3">
      <div>
        <h5 className="form-label mt-3 text-success">Property: {index + 1}</h5>
        <Row>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey"><b>Select Nature Of Property</b></Label>
            <p>{validation[index].propertyNature || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey"><b>Owner of the property</b></Label>
            <p>{validation[index].propertyOwner || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey"><b>Select Status of the property</b></Label>
            <p>{validation[index].propertyStatus || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey"><b>Approximate value of the property</b></Label>
            <p>{formatNumberWithCommas(validation[index].propertyValue) || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey"><b>Property Age (Years)</b></Label>
            <p>{validation[index].propertyAge || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey"><b>Enter Property Address</b></Label>
            <p>{validation[index].address || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey"><b>Enter Property Pincode</b></Label>
            <p>{validation[index].pincode || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey"><b>City</b></Label>
            <p>{validation[index].city || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey"><b>Selected State</b></Label>
            <p>{validation[index].state || '-'}</p>
          </Col>

         {validation[index].parentDeed &&( <Col sm="12" md="6">
            <Label className="mt-1 mb-1 grey">
              <b>Download Parent Deed</b>
            </Label>
            <br />
            <i
              className="mdi mdi-download"
              style={{ fontSize: "25px", cursor: "pointer", color: '#34c38f' }}
              onKeyUp={() => { }}
              onClick={() => {
                formatFunction(validation[index].parentDeed, handleToast)
              }}
            />
          </Col>)}

          {validation[index].saleDeed && (<Col sm="12" md="6">
            <Label className="mt-1 mb-1 grey">
              <b>Download Sale Deed</b>
            </Label>
            <br />
            <i
              className="mdi mdi-download"
              style={{ fontSize: "25px", cursor: "pointer", color: '#34c38f' }}
              onKeyUp={() => { }}
              onClick={() => {
                formatFunction(validation[index].saleDeed, handleToast)
              }}
            />
          </Col>)}

          {validation[index].utilityBills && (<Col sm="12" md="6">
            <Label className="mt-1 mb-1 grey">
              <b>Download Utility Bills</b>
            </Label>
            <br />
            <i
              className="mdi mdi-download"
              style={{ fontSize: "25px", cursor: "pointer", color: '#34c38f' }}
              onKeyUp={() => { }}
              onClick={() => {
                formatFunction(validation[index].utilityBills, handleToast)
              }}
            />
          </Col>)}

          {validation[index].propertyTax && (<Col sm="12" md="6">
            <Label className="mt-1 mb-1 grey">
              <b>Download Property Tax</b>
            </Label>
            <br />
            <i
              className="mdi mdi-download"
              style={{ fontSize: "25px", cursor: "pointer", color: '#34c38f' }}
              onKeyUp={() => { }}
              onClick={() => {
                formatFunction(validation[index].propertyTax, handleToast)
              }}
            />
          </Col>)}
        </Row>

      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </div>
  );

};


function formatFunction(file, showToastCallback) {
  const str = file.substring(file.indexOf("com") + 4);
  const filename = file.substring(file.lastIndexOf("/") + 1);
  const ext = str.split(".").pop();
  const obj = {
    fileName: str,
  };

  downloadSystemConfigFile(obj)
    .then((response) => {
      if (response.code === 200) {
        downloadFile(response.result, ext, filename);
        showToastCallback({
          message: 'Downloading file',
          showToast: true,
          role: "success",
        });
      } else {
        showToastCallback({
          message: response.message,
          showToast: true,
          role: "error",
        });
      }
    })
    .catch((error) => {
    });
}

const formatNumberWithCommas = (number) => {
  if (number) {
    const formattedNumber = number.toString().replace(/\./, ',');
    const parts = formattedNumber.split(',');
    if (parts[0].length > 3) {
      const lastThree = parts[0].substr(parts[0].length - 3);
      const remaining = parts[0].slice(0, parts[0].length - 3);
      parts[0] = remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
    }

    return '₹' + ' ' + parts.join('.');

  }
};